import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA0gziEviU47VLp6RCKKSd3YtaijmvG5Dw",
  authDomain: "goodthing-f50a5.firebaseapp.com",
  projectId: "goodthing-f50a5",
  storageBucket: "goodthing-f50a5.firebasestorage.app",
  messagingSenderId: "124156485479",
  appId: "1:124156485479:web:0de06dec4e6980dbd359c2",
  measurementId: "G-TJQY9FWF0J"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export default app;
